import { showErrorToast } from "../../components/toast.component";
import { AppRouteApi } from "../../config/appRoute";
import {
  ApiResponseContainer,
  ISenderEmail,
  ISenderEmailApi,
} from "../../models/api";
import { AxiosAuth } from "../axios";
import { StorageAuth } from "../localStorage";

async function GetSenderEmail(
  companyId?: string
): Promise<ApiResponseContainer<ISenderEmail>> {
  try {
    const response = await AxiosAuth.get<ApiResponseContainer<ISenderEmail>>(
      AppRouteApi.Company.GetSenderEmail(),
      {
        params: { companyId: companyId || StorageAuth.CompanyId },
      }
    );
    return response.data;
  } catch (error: any) {
    console.error(error);
    return showErrorToast({
      isSuccess: false,
      ...JSON.parse(error.message).data,
    });
  }
}

async function AddSenderEmail(
  data: ISenderEmailApi
): Promise<ApiResponseContainer<ISenderEmailApi>> {
  try {
    const response = await AxiosAuth.put<ApiResponseContainer<ISenderEmailApi>>(
      AppRouteApi.Company.AddEmailPassword(),
      data
    );
    return response.data;
  } catch (error: any) {
    console.error(error);
    return showErrorToast({
      isSuccess: false,
      ...JSON.parse(error.message).data,
    });
  }
}

export const ApiSettings = {
  GetSenderEmail,
  AddSenderEmail,
};
